<template>
  <transition name="fade">
    <div
      v-if="visible"
      class="installer"
      data-test-id="installer"
      @click="$emit('installer-closed')"
    >
      <EButton
        data-test-id="installer-close"
        class="installer__close"
        icon="close"
        variant="bare"
        size="l"
        @click="$emit('installer-closed')"
      />
      <div>
        <ELogoColor class="installer__logo" />
        <ol class="installer__points">
          <li
            v-for="translation in browserTranslations"
            :key="translation"
            v-safe-html="$t(translation)"
            class="installer__point"
          />
        </ol>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex';

import EButton from '~~/common/vue/components/button';
import ELogoColor from '~~/common/vue/components/logos/logo-ecosia.svg';

const browserInstallTranslations = {
  firefox: [
    'common.install.overlay.firefox.point1',
    'common.install.overlay.firefox.point2',
    'common.install.overlay.firefox.point3',
  ],
  ie: [
    'common.install.overlay.ie.point1',
    'common.install.overlay.ie.point2',
    'common.install.overlay.ie.point3',
    'common.install.overlay.ie.point4',
  ],
  edge: [
    'common.install.overlay.edge.point1',
    'common.install.overlay.edge.point2',
    'common.install.overlay.edge.point3',
    'common.install.overlay.edge.point4',
    'common.install.overlay.edge.point5',
    'common.install.overlay.edge.point6',
  ],
};

export default {
  name: 'Install',
  components: {
    EButton,
    ELogoColor,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapState('user', {
      browserName: 'browser',
    }),
    browserTranslations() {
      return browserInstallTranslations[this.browserName || ''];
    },
  },
};
</script>

<style lang="scss" scoped>
.installer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: $z-index-overlay;
  overflow: auto;
  color: var(--color-text-tertiary);
  background-color: rgba($black, $opacity-1l); // Non-standard overlay
  display: flex;
  justify-content: center;
  font-size: $font-1l;
  box-sizing: border-box;
  padding: $space-l;

  @include tablet {
    padding: $space-2l;
    font-size: $font-2l;
  }

  @include desktop {
    font-size: $font-3l;
  }
}

.installer__logo {
  color: $white;
  display: block;
  // most of these pixel values were tailored for the old brand logo
  // TODO: adjust them for the new logo
  margin: 115px auto $space-1l;
  width: 150px;
  height: 82px;

  @include tablet {
    margin-bottom: $space-4l;
    width: 259px;
    height: 117px;
  }
}

.installer__close {
  position: absolute;
  top: $space-l;
  right: $space-l;
  color: $gray-30; // Non-standard DS color

  &:active,
  &:hover,
  &:focus {
    color: var(--color-text-tertiary);
  }
}

.installer__points {
  text-align: left;
  margin: 0;
  padding-left: $font-m;
}

.installer__point {
  margin: 0 0 $space-s;
}

.install__close {
  transform: scale($scale-4l);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity $timing-s $easing;
}
</style>
